import { siteMetadata } from "../gatsby-config"

export const getMailTo = contact =>
  "mailto:" + contact.split(" - ")[1].replace(" at ", "@").replaceAll(' dot ', '.')

export const getPTDate = () =>
  new Date().toLocaleString("pt-BR", {
    day: "numeric",
    month: "short",
    year: "numeric",
  })
export const getENDate = () =>
  new Date().toLocaleString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  })
export const getAcessadoEm = () => `Acessado em ${getPTDate()}.`
export const getAccessedIn = () => `Accessed in ${getENDate()}.`
export const getProjectCitation = (language, link) =>
  language === "pt" ? getPTCitation(link) : getENCitation(link)
export const getPTCitation = url =>
  url
    ? `Disponível em ${url}. ${getAcessadoEm()}`
    : `Disponível em ${siteMetadata.siteUrl}. ${getAcessadoEm()}`
export const getENCitation = url =>
  url
    ? `Available at ${url}. ${getAccessedIn()}`
    : `Available at ${siteMetadata.siteUrl}. ${getAccessedIn()}`
